module.exports = __webpack_public_path__ + "img/map-large-4.2f00ebf0.jpg";